export default (pattern) => {
    return (value) => {
        return RegExp(pattern).test(value);
    };
};
